import { deleteAPI, get, postAPI, putAPI } from "../services/ApiService";
import Swal from "sweetalert2";
export const questionList = async({page=0, recPerPage=50, searchKeyword, countryID, languageID}) => {
    let data = {
        page: page,
        recPerPage: recPerPage,
        q: searchKeyword,
        countryID: countryID,
        languageID: languageID
    }
    let res = await postAPI('/question/list', data)
    return res;
}

export const questionCreate = async({payload}) => {
    let res = await postAPI('/question/save', payload)
    return Swal.fire({
        text:res.message,
        timer: 1500,
    }).then(() => {
        return res;
    })
}

export const questionDetail = async({payload}) => {
    let res = await get('/question/details/'+payload)
    return res;
}

export const questionUpdate = async({id, payload}) => {
    let res = await putAPI('/question/update/'+id, payload)
    return Swal.fire({
        text:res.message,
        timer: 1500,
    }).then(() => {
        return res;
    })
}

export const questionDelete = async({id}) => {
    return Swal.fire({
        text: 'Are you sure you want to delete?',
        confirmButtonText: 'Yes',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
            let res = await deleteAPI('/question/delete/'+id)
            return Swal.fire({
                text:res.message,
                timer: 1500,
            }).then(() => {
                return res;
            })
        }
      })
}

export const validateFormData = (formData) => {
    const{
        countryID, 
        languageID,
        controlTypeID,
        title,
        question,
        
    } = formData;
    const newErrors = {};
    if(!countryID || countryID === 'Select Country') newErrors.countryID = 'Please select country';
    if(!languageID || languageID === 'Select Language') newErrors.languageID = 'Please select language';
    if(!controlTypeID || controlTypeID === 'Select Control Type') newErrors.controlTypeID = 'Please select control type';
    if(!title || title === '') newErrors.title = 'Please enter question no.';
    if(!question || question === '') newErrors.question = 'Please enter question';
    return newErrors
}

export const questionCheckUniqueTitle = async({payload}) => {
    let res = await postAPI('/question/check-unique-title/', payload)
    return res
}